import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { action } from "@ember/object";
import { getOwner } from "@ember/owner";
import curryComponent from "ember-curry-component";
import FKControlCalendar from "discourse/form-kit/components/fk/control/calendar";
import FKControlCheckbox from "discourse/form-kit/components/fk/control/checkbox";
import FKControlCode from "discourse/form-kit/components/fk/control/code";
import FKControlComposer from "discourse/form-kit/components/fk/control/composer";
import FKControlCustom from "discourse/form-kit/components/fk/control/custom";
import FKControlIcon from "discourse/form-kit/components/fk/control/icon";
import FKControlImage from "discourse/form-kit/components/fk/control/image";
import FKControlInput from "discourse/form-kit/components/fk/control/input";
import FKControlMenu from "discourse/form-kit/components/fk/control/menu";
import FKControlPassword from "discourse/form-kit/components/fk/control/password";
import FKControlQuestion from "discourse/form-kit/components/fk/control/question";
import FKControlRadioGroup from "discourse/form-kit/components/fk/control/radio-group";
import FKControlSelect from "discourse/form-kit/components/fk/control/select";
import FKControlTextarea from "discourse/form-kit/components/fk/control/textarea";
import FKControlToggle from "discourse/form-kit/components/fk/control/toggle";
import FKControlWrapper from "discourse/form-kit/components/fk/control-wrapper";
import FKFieldData from "discourse/form-kit/components/fk/field-data";
import FKRow from "discourse/form-kit/components/fk/row";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import templateOnly from "@ember/component/template-only";
const RowColWrapper = setComponentTemplate(createTemplateFactory(
/*
  
  <FKRow as |row|>
    <row.Col @size={{@size}}>
      {{yield}}
    </row.Col>
  </FKRow>

*/
{
  "id": "CsG8ZtZr",
  "block": "[[[1,\"\\n  \"],[8,[32,0],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"Col\"]],null,[[\"@size\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n      \"],[18,3,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[\"row\",\"@size\",\"&default\"],false,[\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/form-kit/components/fk/field.js",
  "scope": () => [FKRow],
  "isStrictMode": true
}), templateOnly(undefined, "field:RowColWrapper"));
const EmptyWrapper = setComponentTemplate(createTemplateFactory(
/*
  
  {{! template-lint-disable no-yield-only }}
  {{yield}}

*/
{
  "id": "n5XyIG/O",
  "block": "[[[1,\"\\n\"],[1,\"  \"],[18,1,null],[1,\"\\n\"]],[\"&default\"],false,[\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/form-kit/components/fk/field.js",
  "isStrictMode": true
}), templateOnly(undefined, "field:EmptyWrapper"));
export default class FKField extends Component {
  get wrapper() {
    if (this.args.size) {
      return RowColWrapper;
    } else {
      return EmptyWrapper;
    }
  }
  componentFor(component, field) {
    const instance = this;
    const baseArguments = {
      get errors() {
        return instance.args.errors;
      },
      unregisterField: instance.args.unregisterField,
      registerField: instance.args.registerField,
      component,
      field
    };
    if (!component.controlType) {
      throw new Error(`Static property \`controlType\` is required on component:\n\n ${component}`);
    }
    return curryComponent(FKControlWrapper, baseArguments, getOwner(this));
  }
  static #_ = (() => dt7948.n(this.prototype, "componentFor", [action]))();
  static #_2 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <FKFieldData
        @name={{@name}}
        @data={{@data}}
        @triggerRevalidationFor={{@triggerRevalidationFor}}
        @title={{@title}}
        @tooltip={{@tooltip}}
        @description={{@description}}
        @helpText={{@helpText}}
        @showTitle={{@showTitle}}
        @collectionIndex={{@collectionIndex}}
        @set={{@set}}
        @addError={{@addError}}
        @validate={{@validate}}
        @validation={{@validation}}
        @onSet={{@onSet}}
        @registerField={{@registerField}}
        @format={{@format}}
        @titleFormat={{@titleFormat}}
        @descriptionFormat={{@descriptionFormat}}
        @disabled={{@disabled}}
        @parentName={{@parentName}}
        @placeholderUrl={{@placeholderUrl}}
        as |field|
      >
        <this.wrapper @size={{@size}}>
          {{yield
            (hash
              Custom=(this.componentFor FKControlCustom field)
              Code=(this.componentFor FKControlCode field)
              Question=(this.componentFor FKControlQuestion field)
              Textarea=(this.componentFor FKControlTextarea field)
              Checkbox=(this.componentFor FKControlCheckbox field)
              Image=(this.componentFor FKControlImage field)
              Password=(this.componentFor FKControlPassword field)
              Composer=(this.componentFor FKControlComposer field)
              Icon=(this.componentFor FKControlIcon field)
              Toggle=(this.componentFor FKControlToggle field)
              Menu=(this.componentFor FKControlMenu field)
              Select=(this.componentFor FKControlSelect field)
              Input=(this.componentFor FKControlInput field)
              RadioGroup=(this.componentFor FKControlRadioGroup field)
              Calendar=(this.componentFor FKControlCalendar field)
              errorId=field.errorId
              id=field.id
              name=field.name
              set=field.set
              value=field.value
            )
          }}
        </this.wrapper>
      </FKFieldData>
    
  */
  {
    "id": "slgiQ5IW",
    "block": "[[[1,\"\\n    \"],[8,[32,0],null,[[\"@name\",\"@data\",\"@triggerRevalidationFor\",\"@title\",\"@tooltip\",\"@description\",\"@helpText\",\"@showTitle\",\"@collectionIndex\",\"@set\",\"@addError\",\"@validate\",\"@validation\",\"@onSet\",\"@registerField\",\"@format\",\"@titleFormat\",\"@descriptionFormat\",\"@disabled\",\"@parentName\",\"@placeholderUrl\"],[[30,1],[30,2],[30,3],[30,4],[30,5],[30,6],[30,7],[30,8],[30,9],[30,10],[30,11],[30,12],[30,13],[30,14],[30,15],[30,16],[30,17],[30,18],[30,19],[30,20],[30,21]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,0,[\"wrapper\"]],null,[[\"@size\"],[[30,23]]],[[\"default\"],[[[[1,\"\\n        \"],[18,24,[[28,[32,1],null,[[\"Custom\",\"Code\",\"Question\",\"Textarea\",\"Checkbox\",\"Image\",\"Password\",\"Composer\",\"Icon\",\"Toggle\",\"Menu\",\"Select\",\"Input\",\"RadioGroup\",\"Calendar\",\"errorId\",\"id\",\"name\",\"set\",\"value\"],[[28,[30,0,[\"componentFor\"]],[[32,2],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,3],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,4],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,5],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,6],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,7],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,8],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,9],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,10],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,11],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,12],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,13],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,14],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,15],[30,22]],null],[28,[30,0,[\"componentFor\"]],[[32,16],[30,22]],null],[30,22,[\"errorId\"]],[30,22,[\"id\"]],[30,22,[\"name\"]],[30,22,[\"set\"]],[30,22,[\"value\"]]]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[22]]]]],[1,\"\\n  \"]],[\"@name\",\"@data\",\"@triggerRevalidationFor\",\"@title\",\"@tooltip\",\"@description\",\"@helpText\",\"@showTitle\",\"@collectionIndex\",\"@set\",\"@addError\",\"@validate\",\"@validation\",\"@onSet\",\"@registerField\",\"@format\",\"@titleFormat\",\"@descriptionFormat\",\"@disabled\",\"@parentName\",\"@placeholderUrl\",\"field\",\"@size\",\"&default\"],false,[\"yield\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/form-kit/components/fk/field.js",
    "scope": () => [FKFieldData, hash, FKControlCustom, FKControlCode, FKControlQuestion, FKControlTextarea, FKControlCheckbox, FKControlImage, FKControlPassword, FKControlComposer, FKControlIcon, FKControlToggle, FKControlMenu, FKControlSelect, FKControlInput, FKControlRadioGroup, FKControlCalendar],
    "isStrictMode": true
  }), this))();
}